import { render, staticRenderFns } from "./CardGrey.vue?vue&type=template&id=dcf8f286&scoped=true&"
import script from "./CardGrey.vue?vue&type=script&lang=js&"
export * from "./CardGrey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf8f286",
  null
  
)

export default component.exports